import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
import api from 'core/util/api';
import { action, observable, runInAction } from 'mobx';
let DeviceSyslogsStatusStore = (_dec = observable.ref, _dec2 = observable.ref, _class = class DeviceSyslogsStatusStore {
  constructor() {
    _initializerDefineProperty(this, "fetched", _descriptor, this);
    _initializerDefineProperty(this, "lastFetched", _descriptor2, this);
    _initializerDefineProperty(this, "fetchPromise", _descriptor3, this);
    _initializerDefineProperty(this, "getDeviceSyslogsStatus", _descriptor4, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "fetched", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "lastFetched", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "fetchPromise", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "getDeviceSyslogsStatus", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return () => {
      if (!this.fetchPromise) {
        this.fetchPromise = api.get('/api/ui/devices/syslog/query').then(results => {
          runInAction(() => {
            this.fetched = true;
            this.lastFetched = results;
          });
          return results;
        });
      }
      return this.fetchPromise;
    };
  }
}), _class);
export const DeviceSyslogsStatus = new DeviceSyslogsStatusStore();